export const HP_B2C_BLACKFRIDAY_UPPER_PROMO =
  'pepeHpB2CBlackFridayUpperPromoPlaylist';

export const B2B_SIGNUP_ALTARES_ISSUE = 'pepeAltaresIssuePlanb';
